import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { PagedResponse } from 'src/app/services/grid-data-source.service';
import { LoggingService } from 'src/app/services/logging.service';
import { environment } from 'src/environments/environment';
import { Inconsistency } from '../models/inconsistency';

@Injectable({
  providedIn: 'root',
})
export class InconsistencyService extends BaseService {
  constructor(
    private http: HttpClient,
    protected override loggingService: LoggingService,
  ) {
    super(loggingService);
  }

  getAllInconsistencies(page: number, pageSize: number, filterObject: any): Observable<PagedResponse<Inconsistency>> {
    return this.http.get<PagedResponse<Inconsistency>>(
      `${environment.UrlApiContract}Notification/GetAllCritical/${page}/${pageSize}`,
      { params: filterObject },
    );
  }

  getInconsistenciesFilters(): Observable<any> {
    return this.http.get<PagedResponse<Inconsistency>>(
      `${environment.UrlApiContract}Notification/GetAllOptionsFiltersNotifications`,
    );
  }
}
